import { render } from "./SecurityMessage.vue?vue&type=template&id=715a2c96&scoped=true&lang=pug"
import script from "./SecurityMessage.vue?vue&type=script&lang=js"
export * from "./SecurityMessage.vue?vue&type=script&lang=js"

import "./SecurityMessage.vue?vue&type=style&index=0&id=715a2c96&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./SecurityMessage.vue?vue&type=custom&index=0&blockType=i18n&locale=en"
if (typeof block0 === 'function') block0(script)
import block1 from "./SecurityMessage.vue?vue&type=custom&index=1&blockType=i18n&locale=es"
if (typeof block1 === 'function') block1(script)


import exportComponent from "/tarball/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-715a2c96"]])

export default __exports__